// Changes with search and menu saperate
// import {
//   Avatar,
//   Badge,
//   Box,
//   Button,
//   Drawer,
//   IconButton,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import React, { useState } from "react";
// // import "./Navbar.css";
// import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
// import SearchIcon from "@mui/icons-material/Search";
// import MenuIcon from "@mui/icons-material/Menu";
// import { mainCategory } from "../../../data/category/mainCategory";
// import CategorySheet from "./CategorySheet";
// import DrawerList from "./DrawerList";
// import { useNavigate } from "react-router-dom";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { fetchUserProfile } from "../../../Redux Toolkit/Customer/UserSlice";
// import { FavoriteBorder } from "@mui/icons-material";
// import NotificationBar from "./NotificationBar";

// const Navbar = () => {
//   const [showSheet, setShowSheet] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState("men");

//   const theme = useTheme();
//   const isLarge = useMediaQuery(theme.breakpoints.up("lg"));

//   const dispatch = useAppDispatch();
//   const { user, cart, sellers } = useAppSelector((store) => store);

//   const navigate = useNavigate();
//   const [open, setOpen] = React.useState(false);

//   const toggleDrawer = (newOpen: boolean) => () => {
//     setOpen(newOpen);
//   };

//   const becomeSellerClick = () => {
//     if (sellers.profile?.id) {
//       navigate("/seller");
//     } else {
//       navigate("/become-seller");
//     }
//   };

//   return (
//     <Box
//       sx={{ zIndex: 1400 }}
//       className="sticky top-0 left-0 right-0 relative bg-white"
//     >
//       <NotificationBar />

//       {/* FIRST ROW: Logo + Search + Login/Profile + Wishlist + Cart */}
//       <div className="flex items-center justify-between gap-3 px-4 md:px-6 lg:px-20 h-14 md:h-[70px] bg-white">
//         <div className="flex items-center gap-2 flex-shrink-0">
//           {!isLarge && (
//             <IconButton onClick={toggleDrawer(true)}>
//               <MenuIcon
//                 className="text-gray-700"
//                 sx={{ fontSize: { xs: 22, sm: 24, md: 27 } }}
//               />
//             </IconButton>
//           )}

//           <h1
//             onClick={() => navigate("/")}
//             className="logo flex items-center gap-2 cursor-pointer text-lg md:text-2xl text-[#00927c] whitespace-nowrap"
//           >
//             <img
//               src="/logo.png"
//               alt="Priya Beads Logo"
//               className="h-10 sm:h-12 md:h-20 w-auto"
//             />
//             Priya Beads
//           </h1>
//         </div>

//         {/* Desktop search bar */}
//         {isLarge && (
//           <div
//             onClick={() => navigate("/search-products")}
//             className="flex-1 max-w-2xl mx-8 h-12 border rounded-md flex items-center justify-between px-4 cursor-pointer bg-white"
//           >
//             <span className="text-gray-500 text-sm">
//               Search for beads, charms, findings & more...
//             </span>
//             <SearchIcon className="text-gray-700" />
//           </div>
//         )}

//         <div className="flex items-center gap-2 sm:gap-3 md:gap-4 lg:gap-5 flex-shrink-0">
//           {!isLarge && (
//             <IconButton onClick={() => navigate("/search-products")}>
//               <SearchIcon
//                 className="text-gray-700"
//                 sx={{ fontSize: { xs: 18, sm: 20, md: 23 } }}
//               />
//             </IconButton>
//           )}

//           {user.user ? (
//             <Button
//               onClick={() => navigate("/account/profile")}
//               className="!min-w-0 flex items-center gap-2"
//             >
//               <Avatar
//                 sx={{
//                   width: { xs: 22, sm: 23, md: 24, lg: 25 },
//                   height: { xs: 22, sm: 23, md: 24, lg: 25 },
//                 }}
//                 src="https://cdn.pixabay.com/photo/2015/04/15/09/28/head-723540_640.jpg"
//               />
//               <span className="font-semibold hidden lg:inline-block max-w-[90px] truncate normal-case">
//                 {user.user?.fullName?.split(" ")[0]}
//               </span>
//             </Button>
//           ) : (
//             <Button
//               variant="contained"
//               startIcon={
//                 <AccountCircleIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />
//               }
//               sx={{
//                 px: { xs: 1.25, sm: 1.5, md: 2 },
//                 py: { xs: 0.5, sm: 0.75 },
//                 fontSize: { xs: 12, sm: 13, md: 14 },
//                 whiteSpace: "nowrap",
//               }}
//               onClick={() => navigate("/login")}
//             >
//               Login
//             </Button>
//           )}

//           <IconButton onClick={() => navigate("/wishlist")}>
//             <FavoriteBorder
//               sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
//               className="text-gray-700"
//             />
//           </IconButton>

//           <IconButton onClick={() => navigate("/cart")}>
//             <Badge
//               badgeContent={cart.cart?.cartItems.length}
//               color="primary"
//               sx={{
//                 "& .MuiBadge-badge": {
//                   fontSize: { xs: 10, md: 11, lg: 12 },
//                   minWidth: { xs: 16, md: 18, lg: 20 },
//                   height: { xs: 16, md: 18, lg: 20 },
//                 },
//               }}
//             >
//               <AddShoppingCartIcon
//                 sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
//                 className="text-gray-700"
//               />
//             </Badge>
//           </IconButton>
//         </div>
//       </div>

//       {/* SECOND ROW: Menu */}
//       {isLarge && (
//         // <div className="h-[52px] border-b bg-[#e6f7f3] flex items-center justify-center">
//         // <div className="h-[52px] border-b bg-[#d2f0e8] flex items-center justify-center">
//         <div className="h-[52px] border-b bg-[#081025] flex items-center justify-center">
//           {/* <ul className="flex items-center justify-center font-medium text-gray-800"> */}
//           <ul className="flex items-center justify-center font-medium text-white">
//             {mainCategory.map((item) => (
//               <li
//                 key={item.categoryId}
//                 onMouseLeave={() => {
//                   setShowSheet(false);
//                 }}
//                 onMouseEnter={() => {
//                   setSelectedCategory(item.categoryId);
//                   setShowSheet(true);
//                 }}
//                 className="mainCategory hover:text-[#00927c] cursor-pointer hover:border-b-2 h-[52px] px-6 border-[#00927c] flex items-center whitespace-nowrap"
//               >
//                 {item.name}
//               </li>
//             ))}
//           </ul>
//         </div>
//       )}

//       <Drawer open={open} onClose={toggleDrawer(false)}>
//         <DrawerList toggleDrawer={toggleDrawer} />
//       </Drawer>

//       {showSheet && selectedCategory && (
//         <div
//           onMouseLeave={() => setShowSheet(false)}
//           onMouseEnter={() => setShowSheet(true)}
//           className="categorySheet absolute top-full left-20 right-20 z-[1500] bg-white"
//         >
//           <CategorySheet
//             setShowSheet={setShowSheet}
//             selectedCategory={selectedCategory}
//           />
//         </div>
//       )}
//     </Box>
//   );
// };

// export default Navbar;



import {
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SearchIcon from "@mui/icons-material/Search";
import MenuIcon from "@mui/icons-material/Menu";
import { mainCategory } from "../../../data/category/mainCategory";
import CategorySheet from "./CategorySheet";
import DrawerList from "./DrawerList";
import { useNavigate, useSearchParams } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { fetchUserProfile } from "../../../Redux Toolkit/Customer/UserSlice";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { FavoriteBorder } from "@mui/icons-material";
import NotificationBar from "./NotificationBar";

const Navbar = () => {
  const [showSheet, setShowSheet] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("men");
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const dispatch = useAppDispatch();

  const { user, auth, cart, sellers, wishlist } = useAppSelector((store) => store);
  const hasWishlistItems = (wishlist.wishlist?.products?.length || 0) > 0;

  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const becomeSellerClick = () => {
    if (sellers.profile?.id) {
      navigate("/seller");
    } else navigate("/become-seller");
  };

  const compactIconButtonSx = {
    p: { xs: 0.75, sm: 1 },
  };

  return (
    <Box
      sx={{ zIndex: 1400 }}
      className="sticky top-0 left-0 right-0 relative bg-white"
    >
      <NotificationBar />

      <div className="flex items-center justify-between px-2 sm:px-4 md:px-6 lg:px-20 h-14 md:h-[70px] border-b bg-white">
        <div className="flex items-center gap-1 sm:gap-3 md:gap-9 min-w-0">
          <div className="flex items-center gap-1 sm:gap-2 min-w-0">
            {!isLarge && (
              <IconButton
                sx={compactIconButtonSx}
                onClick={() => toggleDrawer(true)()}
              >
                <MenuIcon
                  className="text-gray-700"
                  sx={{ fontSize: { xs: 22, sm: 24, md: 27, lg: 29 } }}
                />
              </IconButton>
            )}

            <h1
              onClick={() => navigate("/")}
              className="logo flex items-center gap-1 sm:gap-2 cursor-pointer text-[18px] sm:text-xl md:text-2xl text-[#00927c] whitespace-nowrap leading-none flex-shrink-0"
            >
              <img
                src="/logo.png"
                alt="Priya Beads Logo"
                className="h-8 sm:h-10 md:h-20 w-auto flex-shrink-0"
              />
              Priya Beads
            </h1>
          </div>

          {isLarge && (
            <ul className="flex items-center font-medium text-gray-800">
              {mainCategory.map((item) => (
                <li
                  key={item.categoryId}
                  onMouseLeave={() => {
                    setShowSheet(false);
                  }}
                  onMouseEnter={() => {
                    setSelectedCategory(item.categoryId);
                    setShowSheet(true);
                  }}
                  className="mainCategory hover:text-[#00927c] cursor-pointer hover:border-b-2 h-[70px] px-4 border-[#00927c] flex items-center"
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="flex items-center gap-0.5 sm:gap-2 md:gap-4 lg:gap-6 flex-shrink-0">
          <IconButton
            sx={compactIconButtonSx}
            onClick={() => navigate("/search-products")}
          >
            <SearchIcon
              className="text-gray-700"
              sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
            />
          </IconButton>

          {user.user ? (
            <Button
              onClick={() => navigate("/account/profile")}
              className="flex items-center gap-1 sm:gap-2"
              sx={{
                minWidth: "auto",
                px: { xs: 0.25, sm: 0.75, md: 1 },
                py: { xs: 0.25, sm: 0.5 },
              }}
            >
              {/* <Avatar
                sx={{
                  width: { xs: 22, sm: 23, md: 24, lg: 25 },
                  height: { xs: 22, sm: 23, md: 24, lg: 25 },
                  flexShrink: 0,
                }}
                src="https://cdn.pixabay.com/photo/2015/04/15/09/28/head-723540_640.jpg"
              />

              <h1 className="font-semibold hidden lg:block">
                {user.user?.fullName?.split(" ")[0]}
              </h1> */}

              <Avatar
                className="lg:hidden"
                sx={{
                  width: { xs: 22, sm: 23, md: 24 },
                  height: { xs: 22, sm: 23, md: 24 },
                }}
                src="https://cdn.pixabay.com/photo/2015/04/15/09/28/head-723540_640.jpg"
              />

              <h1 className="font-semibold hidden lg:block normal-case">
                {user.user?.fullName?.split(" ")[0]}
              </h1>

            </Button>
          ) : (
            <Button
              variant="contained"
              startIcon={
                <AccountCircleIcon sx={{ fontSize: { xs: 14, sm: 16 } }} />
              }
              sx={{
                px: { xs: 1.25, sm: 1.5, md: 2 },
                py: { xs: 0.5, sm: 0.75 },
                fontSize: { xs: 12, sm: 13, md: 14 },
                minWidth: "auto",
              }}
              onClick={() => navigate("/login")}
            >
              Login
            </Button>
          )}

          <IconButton sx={compactIconButtonSx} onClick={() => navigate("/wishlist")}>
            <Badge
              variant="dot"
              color="primary"
              invisible={!hasWishlistItems}
              sx={{
                "& .MuiBadge-badge": {
                  minWidth: { xs: 7, md: 8 },
                  height: { xs: 7, md: 8 },
                  borderRadius: "50%",
                },
              }}
            >
              <FavoriteBorder
                sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
                className="text-gray-700"
              />
            </Badge>
          </IconButton>

          <IconButton sx={compactIconButtonSx} onClick={() => navigate("/cart")}>
            <Badge
              badgeContent={cart.cart?.cartItems.length}
              color="primary"
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: { xs: 10, md: 11, lg: 12 },
                  minWidth: { xs: 16, md: 18, lg: 20 },
                  height: { xs: 16, md: 18, lg: 20 },
                },
              }}
            >
              <AddShoppingCartIcon
                sx={{ fontSize: { xs: 18, sm: 20, md: 23, lg: 25 } }}
                className="text-gray-700"
              />
            </Badge>
          </IconButton>
        </div>
      </div>

      <Drawer open={open} onClose={toggleDrawer(false)}>
        <DrawerList toggleDrawer={toggleDrawer} />
      </Drawer>

      {showSheet && selectedCategory && (
        <div
          onMouseLeave={() => setShowSheet(false)}
          onMouseEnter={() => setShowSheet(true)}
          className="categorySheet absolute top-full left-20 right-20 z-[1500] bg-white"
        >
          <CategorySheet
            setShowSheet={setShowSheet}
            selectedCategory={selectedCategory}
          />
        </div>
      )}
    </Box>
  );
};

export default Navbar;